// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_header__bU\\+de{
    color: #18316e;
    margin-bottom: 1rem;
}

.styles_buttons__XAzzg{
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
}

.styles_sucess__oZfEf{
    color: #18316e;
    text-align: center;
    margin-bottom: 1rem;
}

.styles_sucess__oZfEf h3 {
    margin-bottom: 1rem;
}

.styles_close_sucess__eWyf7{
    display: flex;
    justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/pages/Vinculos/ModalEmailParceiro/styles.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B","sourcesContent":[".header{\n    color: #18316e;\n    margin-bottom: 1rem;\n}\n\n.buttons{\n    display: flex;\n    justify-content: space-between;\n    margin-top: 1rem;\n}\n\n.sucess{\n    color: #18316e;\n    text-align: center;\n    margin-bottom: 1rem;\n}\n\n.sucess h3 {\n    margin-bottom: 1rem;\n}\n\n.close_sucess{\n    display: flex;\n    justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `styles_header__bU+de`,
	"buttons": `styles_buttons__XAzzg`,
	"sucess": `styles_sucess__oZfEf`,
	"close_sucess": `styles_close_sucess__eWyf7`
};
export default ___CSS_LOADER_EXPORT___;
